import React from 'react';
import { createBrowserHistory } from 'history';
import {Row, Col, Nav, NavItem } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import './Header.scss';
import { USERS, STATIC, ABOUT_URL, RESOURCES_URL, PRIVACY_URL } from '../../Views/ConstPaths';

//Presentational component to show the Footer which includes a few links, copyright info, etc..

//Bootstrap notes:
// "container": responsive, fixed-width. max-width changes at each breakpoint. https://getbootstrap.com/docs/5.0/layout/containers/
// With BS 5, don't need an "ml-auto" class on Nav to push all the way to the right
//Will need to add toggler functions if we want to collapse the menu on smaller screen sizes.

function Footer(props) {

  const history = createBrowserHistory();
  
  let inEval = true;
  if (history.location.pathname === "/" || history.location.pathname.startsWith(USERS) || history.location.pathname.startsWith(STATIC)){
    inEval = false;
  }


  //using .btn and .btn-link for styling (.nav-link also works but looks a bit different color-wise and no underline)
  return(
    <div className={"container-fluid border-top aa-footer-container" + (inEval ? " aa-header-color-eval" : " aa-header-color-reg")}>
      <Row>
        <Col>
          <Nav className="justify-content-center">
            <NavItem>
              <NavLink to={ABOUT_URL} className="btn btn-link">
                About
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to={RESOURCES_URL} className="btn btn-link">
                Resources
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to={PRIVACY_URL} className="btn btn-link">
                Privacy Policy
              </NavLink>
            </NavItem>
          </Nav>
        </Col>
      </Row>
      <Row>
        <Col>
          <img className="footer-logo"
            src="/images/AccessNavigatorlogo_horiz.png" 
            // src="/images/Accessnavigator_finallogo-01.png" 
            alt="Access Navigator logo"
          />
        </Col>
      </Row>
      <Row>
        <Col className="copyright">
          &copy; 2025 The RERC on AAC. All rights reserved. v1.0-beta
        </Col>
      </Row>
    </div>
  );
}

export default Footer;
